"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('calendarConfiguration', {
    mailboxJunkEmailConfiguration: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/store/store.js
// module id = 3379
// module chunks = 2